import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .radioWrapper {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: var(--color-text);
    height: 24px;
    cursor: pointer;
    margin: 12px 0;

    &.disabled {
      color: var(--color-text-disabled);
      cursor: auto;
    }

    .text {
      display: inline-block;
      margin-left: 10px;
    }
  }

  .customTable {
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;

    tbody td > * {
      width: 100%;
    }
  }
`;
